import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_11: FaireProductEntity = {
  token: "legacy_prod_abbott-11",
  type: "product",
  name: "Grey LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f64ddfb4aa77a080fc5f162378cb65b70086bbf2b69c1899de0fab7ce1b80b81.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
